import { Router, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
    ) { }
  GoToHomePage(){
    this.router.navigate(['/']);
  }
  GoToSetting(id: string){
    this.router.navigate(['/setting/' + id]);
  }
  GoToControl(id: string){
    this.router.navigate(['/control/' + id]);
  }
  GoToOverview(id: string){
    this.router.navigate(['/overview/' + id]);
  }
  GoToLottery(id: string){
    this.router.navigate(['/lottery/' + id]);
  }
  GoToPlayDonate(id: string){
    this.router.navigate(['/play-donate/' + id]);
  }
  GoToPlayVideo(id: string){
    this.router.navigate(['/play-video/' + id]);
  }
  GoToDonate(id: string){
    this.router.navigate(['/donate/' + id]);
  }
}

